import {MeasurementStatus} from "../found-measurement";
import {AssignType} from "../list-item";

export function canReassignMeasurement({assignType, status}: {
  status: MeasurementStatus;
  assignType: AssignType | undefined;
}) {
  return status === "READY_FOR_ANALYSIS"
    && assignType === "DOCTOR";
}
